import AuthProvider from 'context/AuthProvider'
import CoreUIProviderAdapter from 'context/CoreUIProviderAdapter'
import I18nProvider from 'context/I18nProvider'
import QueryProvider from 'context/QueryProvider'
import { createRoot } from 'react-dom/client'
import '@eleo-rh/core-ui/styles/index.css'
import Auth from 'services/auth'
import QueryClient from 'services/query'
import { getDefaultLocale } from 'utils/locale'
import App from './app'
import './style.css'

const locale = getDefaultLocale()
const queryClient = new QueryClient(locale)
const authService = new Auth({ queryClient })

if (process.env.NODE_ENV === 'development' && process.env.SYMFONY_TOOLBAR) {
  void import('./toolbar')
}

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element not found')
}

if (process.env.NODE_ENV === 'production') {
  window.addEventListener('vite:preloadError', event => {
    const lastReloadAt = Number(window.sessionStorage.getItem('vite:preloadErrorReloadAt') || 0)

    if (Date.now() - lastReloadAt < 10_000) return

    event.preventDefault()
    window.sessionStorage.setItem('vite:preloadErrorReloadAt', String(Date.now()))
    window.location.reload()
  })
}

const root = createRoot(rootElement)

root.render(
  <AuthProvider auth={authService}>
    <QueryProvider client={queryClient}>
      <I18nProvider>
        <CoreUIProviderAdapter>
          <App client={queryClient} />
        </CoreUIProviderAdapter>
      </I18nProvider>
    </QueryProvider>
  </AuthProvider>,
)
